import { makeRequest } from 'utils/requestLogger';

// Payload will be in the format of { invite_code }
export default (id, payload) =>
  makeRequest('put', `/api/users/${id}/upgrade-user`, payload);



// WEBPACK FOOTER //
// ./src/app/services/account/upgradeUser.js